import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {

  connect() {
    this.originalUrl = window.location.href

    // Get existing Bootstrap offcanvas instance or create new one
    this.offcanvas = bootstrap.Offcanvas.getInstance(this.element) || new bootstrap.Offcanvas(this.element, {backdrop: true, scroll: true})

    this.element.addEventListener('turbo:frame-load', (event) => {
      // Only open if the offcanvas is not already visible
      // This prevents focus stealing from inline edit forms
      if (!this.offcanvas._isShown) {
        this.open()
      }
    })

    // Listen for custom close event from inner turbo frame
    this.customCloseHandler = this.handleCustomClose.bind(this)
    window.addEventListener('close-offcanvas', this.customCloseHandler)
  }

  disconnect() {
    // Clean up event listener
    window.removeEventListener('close-offcanvas', this.customCloseHandler)
  }

  handleCustomClose(event) {
    this.offcanvas.hide()
    window.history.pushState({}, '', this.originalUrl);
  }

  open() {
    this.offcanvas.show()
  }

  close(event) {
    event.preventDefault();
    this.offcanvas.hide()
    window.history.pushState({}, '', this.originalUrl);
  }

  closeAndNavigate(event) {
    // Close offcanvas without preventing default link behavior
    this.offcanvas.hide()
    window.history.pushState({}, '', this.originalUrl);
  }
}
